module.exports = __webpack_public_path__ + "static/img/804689842.1f9ae8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/804689842.jpg
// module id = i9XZ
// module chunks = 0